/**
 * Text Block Renderer
 * Renders markdown content using the existing Response component
 */

import React from "react";
import { Response } from "@strivelabs/ui-blocks";
import type { UIBlock } from "@/types/ui-blocks";

export interface TextBlockRendererProps {
  block: UIBlock;
}

function normalizeEscapes(text: string): string {
  return text
    .replace(/\\n/g, '\n')
    .replace(/\n+/g, '\n\n');
}

export function TextBlockRenderer({ block }: TextBlockRendererProps) {
  const rawContent = block.type === 'text' ? block.content : '';
  const processed = React.useMemo(
    () => normalizeEscapes(rawContent),
    [rawContent]
  );

  if (block.type !== 'text') return null;

  return <Response>{processed}</Response>;
}
